import React, { useState } from "react";
import {
  Button,
  Card,
  Col,
  Input,
  Modal,
  Row,
  Select,
  InputNumber,
  message,
  Spin,
} from "antd";
import { Form, Icon } from "@ant-design/compatible";
import api from "../../../../api";
import strings from "../../../../strings";

const Option = Select.Option;
const FormItem = Form.Item;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const RenewMerchantSubscription = (props) => {
  const [loading, setLoading] = useState(false);
  const { form } = props;
  const { getFieldDecorator } = form;

  const planOptions = ["Free", "Basic", "Basic Plus", "Pro","Pro Plus", "Nitro"];
  const currencyOptions = ["NGN", "USD", "GBP", "EUR", "GHS", "KES", "ZAR", "UGX", "TZS", "RWF"];

  const handleSubmit = (e) => {
    e.preventDefault();
    form.validateFields(async (err, values) => {
      if (err) {
        return;
      }

      const { merchantEmail, plan, currency_code, no_of_days, transaction_reference } = values;

      const subscriptionData = {
        plan,
        currency_code,
        no_of_days,
        transaction_reference,
      };

      setLoading(true);

      try {
        const response = await api.merchants.addMerchantCurrentPlan(
          merchantEmail,
          subscriptionData
        );

        if (response.status === 200 || response.status === 201) {
          Modal.success({
            title: strings.subscriptionRenewedSuccessfully,
            content: `Successfully renewed subscription for ${merchantEmail}`,
            okText: "OK",
            onOk: () => {
              form.resetFields();
            },
          });
        }
      } catch (error) {
        console.error("Error renewing subscription:", error);
        const errorMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Failed to renew subscription";
        Modal.error({
          title: strings.error,
          content: errorMessage,
        });
      } finally {
        setLoading(false);
      }
    });
  };

  return (
    <Card
      title={strings.renewMerchantSubscription}
      bordered={false}
    >
      <Spin spinning={loading} indicator={antIcon}>
        <Form onSubmit={handleSubmit} layout="vertical">
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <FormItem label={strings.merchantEmail}>
                {getFieldDecorator("merchantEmail", {
                  rules: [
                    {
                      required: true,
                      message: strings.pleaseEnterMerchantEmail,
                    },
                    {
                      type: "email",
                      message: strings.pleaseEnterValidEmail || "Please enter a valid email",
                    },
                  ],
                })(
                  <Input
                    size="large"
                    placeholder={strings.enterMerchantEmail}
                  />
                )}
              </FormItem>
            </Col>

            <Col xs={24} md={12}>
              <FormItem label={strings.plan}>
                {getFieldDecorator("plan", {
                  rules: [
                    {
                      required: true,
                      message: strings.pleaseSelectPlan,
                    },
                  ],
                })(
                  <Select
                    size="large"
                    placeholder={strings.selectPlan}
                  >
                    {planOptions.map((plan) => (
                      <Option key={plan} value={plan}>
                        {plan}
                      </Option>
                    ))}
                  </Select>
                )}
              </FormItem>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} md={12}>
              <FormItem label={strings.currencyCode}>
                {getFieldDecorator("currency_code", {
                  rules: [
                    {
                      required: true,
                      message: strings.pleaseSelectCurrency,
                    },
                  ],
                })(
                  <Select
                    size="large"
                    placeholder={strings.selectCurrency}
                    showSearch
                    optionFilterProp="children"
                  >
                    {currencyOptions.map((currency) => (
                      <Option key={currency} value={currency}>
                        {currency}
                      </Option>
                    ))}
                  </Select>
                )}
              </FormItem>
            </Col>

            <Col xs={24} md={12}>
              <FormItem label={strings.numberOfDays}>
                {getFieldDecorator("no_of_days", {
                  rules: [
                    {
                      required: true,
                      message: strings.pleaseEnterNumberOfDays,
                    },
                  ],
                })(
                  <InputNumber
                    size="large"
                    min={1}
                    style={{ width: "100%" }}
                    placeholder={strings.enterNumberOfDays}
                  />
                )}
              </FormItem>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24}>
              <FormItem label={strings.transactionReference}>
                {getFieldDecorator("transaction_reference", {
                  rules: [
                    {
                      required: true,
                      message: strings.pleaseEnterTransactionReference,
                    },
                  ],
                })(
                  <Input
                    size="large"
                    placeholder={strings.enterTransactionReference}
                  />
                )}
              </FormItem>
            </Col>
          </Row>

          <Row>
            <Col xs={24}>
              <FormItem>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  loading={loading}
                  style={{ marginTop: "16px" }}
                >
                  {strings.renewSubscription}
                </Button>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Spin>
    </Card>
  );
};

const RenewMerchantSubscriptionForm = Form.create()(RenewMerchantSubscription);

export default RenewMerchantSubscriptionForm;
